import { styled } from 'styled-components';

export const DeviceQueries = {
  smallMobile: 'max-width: 550px',
  mobile: 'max-width: 767px',
  notMobile: 'min-width: 768px',
  laptop: 'min-width: 1020px'
};

export const VerticalFullContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  flex-grow: 1;
  overflow: auto;
`;

export const MobileShow = styled.div`
  display: contents;

  @media not (${DeviceQueries.mobile}) {
    display: none;
  }
`;

export const DesktopShow = styled.div`
  display: contents;

  @media (${DeviceQueries.mobile}) {
    display: none;
  }
`;
